const ANALYTICS_OWNER_IDENTITY = 'postmaster@analytics.msging.net';
import './Integrations.scss';
import { DashbotActionFeatures } from './dashbot/DashbotActionFeatures';
import HubspotActionFeatures from './hubspot/HubspotActionFeatures';
import { blipStoreStateName } from 'modules/blipStore';
import { blipStoreStateExtensionsDetail } from 'modules/blipStore';
import { BlipStoreFeatures } from 'modules/blipStore/BlipStoreFeatures';
import { IntegrationsFeatures } from 'modules/application/detail/integrations/IntegrationsFeatures';
const BLIP_STORE_PARAMETER_BOT_HOME_JOURNEY = 'Integrations';
const BLIP_STORE_INDICATED_VIEW_ALL_CLICKED_TRACKING = 'integrations-indicated-extensions-view-all-clicked';
const BLIP_STORE_INDICATED_EXTENSION_CLICKED_TRACKING = 'integrations-indicated-extensions-clicked';
const BLIP_STORE_INDICATED_EXTENSION_MORE_CLICKED_TRACKING = 'integrations-indicated-extensions-more-clicked';
const BLIP_STORE_INDICATED_EXTENSION_DISCOVERY_CLICKED_TRACKING = 'integrations-indicated-extensions-discovery-clicked';
const BLIP_STORE_DICOVERY_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSea8H6lo1_Hd2aNE-XGGSKreBjW8w9auhHJSkl7kTJxq4EPCw/viewform';
// tslint:disable-next-line:quotemark
export const BOTANALYTICS_ACTIVE = 'Botanalytics.IsValid';
export const DASHBOT_ACTIVE = 'Dashbot.IsValid';
export const RDSTATION_ACTIVE = 'RdStation.IsValid';
export const RDSTATION_INSTALLATION_TYPE = 'RdStation.InstallationType';
export const RDSTATION_OAUTH_INSTALLATION = 'OAuthTokenInstallation';
export const RDSTATION_PUBLIC_TOKEN = 'RdStation.PublicToken';
export const HUBSPOT_ACTIVE = 'Hubspot.IsValid';
export const WEBHOOK_ACTIVE = 'Webhook.IsValid';
export const INTEGRATIONS_BUCKET = 'blip_portal:integrations_config';
export class IntegrationsController {
    static $inject = ['application', '$translate', '$state', 'ConfigurationsService', 'IntegrationsSegmentService', 'ExternalBlipStoreService', 'SegmentService', '$location', 'TranslateService'];
    constructor(application, $translate, $state, ConfigurationsService, IntegrationsSegmentService, ExternalBlipStoreService, SegmentService, $location, TranslateService) {
        'ngInject';
        this.application = application;
        this.$translate = $translate;
        this.$state = $state;
        this.ConfigurationsService = ConfigurationsService;
        this.IntegrationsSegmentService = IntegrationsSegmentService;
        this.ExternalBlipStoreService = ExternalBlipStoreService;
        this.SegmentService = SegmentService;
        this.$location = $location;
        this.TranslateService = TranslateService;
        this.enableDashbot = false;
        this.enableHubspot = false;
        this.enableRdStation = false;
        this.isDiscoverExtensionsEnabled = false;
        this.extensionsPage = 8;
    }
    async $onInit() {
        try {
            await this.checkFeatures();
            await this.fetchConfiguration();
            await this.fetchRdStationConfiguration();
            if (this.isBlipStoreIntegrationsPluginsRecommendationServicePageEnabled === true) {
                const language = await this.TranslateService.getCurrentLanguage();
                await this.GetExtensionsByParameter(language);
            }
            this.IntegrationsSegmentService.setApplication(this.application);
            this.trackOpened();
        }
        catch (e) {
            console.error(e);
        }
    }
    async checkFeatures() {
        this.enableDashbot = await DashbotActionFeatures.dashbotActionApplicationEnabled();
        this.enableHubspot = await HubspotActionFeatures.hubspotActionApplicationEnabled();
        this.enableRdStation = await IntegrationsFeatures.rdStationIntegrationSetEnabled();
        this.isBlipStoreIntegrationsPluginsRecommendationServicePageEnabled = await BlipStoreFeatures.isBlipStoreIntegrationsPluginsRecommendationServicePageEnabled();
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await IntegrationsFeatures.isConfigurationsDomainOnChannelsOperationsGetEnabled();
    }
    async fetchConfiguration() {
        try {
            this.setButtonsLoading(true);
            await this.setDefaultText();
            const settings = await this.ConfigurationsService.get(ANALYTICS_OWNER_IDENTITY, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            const connectedText = await this.$translate('utils.forms.connected');
            this.checkWebhook(settings, connectedText);
            this.checkDashbot(settings, connectedText);
            this.checkBotanalytics(settings, connectedText);
            this.checkHubspot(settings, connectedText);
        }
        catch (e) {
            this.isWebhookActive = false;
        }
        finally {
            this.setButtonsLoading(false);
        }
    }
    setButtonsLoading(status) {
        this.webhookButtonLoading = status;
        this.dashbotButtonLoading = status;
        this.botanalyticsButtonLoading = status;
        this.hubSpotButtonLoading = status;
    }
    async setDefaultText() {
        const connectText = await this.$translate('utils.forms.connect');
        this.webhookButtonText = connectText;
        this.dashbotButtonText = connectText;
        this.botanalyticsButtonText = connectText;
        this.hubSpotButtonText = connectText;
    }
    checkWebhook(settings, conectedText) {
        this.isWebhookActive =
            settings[WEBHOOK_ACTIVE] && settings[WEBHOOK_ACTIVE].toLowerCase() == 'true'
                ? true
                : false;
        if (this.isWebhookActive) {
            this.webhookButtonText = conectedText;
        }
    }
    checkDashbot(settings, conectedText) {
        this.isDashbotActive =
            settings[DASHBOT_ACTIVE] && settings[DASHBOT_ACTIVE].toLowerCase() == 'true'
                ? true
                : false;
        if (this.isDashbotActive) {
            this.dashbotButtonText = conectedText;
        }
    }
    checkBotanalytics(settings, conectedText) {
        this.isBotanalyticsActive =
            settings[BOTANALYTICS_ACTIVE] && settings[BOTANALYTICS_ACTIVE].toLowerCase() == 'true'
                ? true
                : false;
        if (this.isBotanalyticsActive) {
            this.botanalyticsButtonText = conectedText;
        }
    }
    checkHubspot(settings, connectedText) {
        this.isHubSpotActive =
            settings[HUBSPOT_ACTIVE] && settings[HUBSPOT_ACTIVE].toLowerCase() == 'true'
                ? true
                : false;
        if (this.isHubSpotActive) {
            this.hubSpotButtonText = connectedText;
        }
    }
    async fetchRdStationConfiguration() {
        try {
            this.rdStationButtonLoading = true;
            this.rdStationButtonText = await this.$translate('utils.forms.connect');
            const settings = await this.ConfigurationsService.get(ANALYTICS_OWNER_IDENTITY, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            this.isRdStationActive =
                settings[RDSTATION_ACTIVE].toLowerCase() == 'true'
                    ? true
                    : false;
            if (this.isRdStationActive) {
                this.rdStationButtonText = await this.$translate('utils.forms.connected');
            }
        }
        catch (e) {
            this.isRdStationActive = false;
        }
        finally {
            this.rdStationButtonLoading = false;
        }
    }
    goToState(state) {
        this.$state.go(state);
        const stateArray = state.split('.');
        const integration = stateArray[stateArray.length - 1];
        this.IntegrationsSegmentService.trackConnectionOpened(integration);
    }
    // Segment
    trackOpened() {
        this.IntegrationsSegmentService.trackOpened();
    }
    async GetExtensionsByParameter(language) {
        this.extensions = await this.ExternalBlipStoreService.GetExtensionsByParameter(this.application.tenantId, language, BLIP_STORE_PARAMETER_BOT_HOME_JOURNEY);
    }
    getExtensionsPaged() {
        if (this.extensions === undefined) {
            return [];
        }
        const extensionsPaged = this.extensions.filter((extension, index) => index < this.extensionsPage && extension);
        return extensionsPaged;
    }
    onOpenMoreExtensions() {
        this.SegmentService.createTrack(BLIP_STORE_INDICATED_EXTENSION_MORE_CLICKED_TRACKING);
        this.extensionsPage += 8;
        if (this.extensionsPage >= this.extensions.length) {
            this.isDiscoverExtensionsEnabled = true;
        }
    }
    onOpenFormDiscoveryExtensions() {
        this.SegmentService.createTrack(BLIP_STORE_INDICATED_EXTENSION_DISCOVERY_CLICKED_TRACKING);
        window.open(BLIP_STORE_DICOVERY_FORM_URL, '_blank');
    }
    onOpenBlipStore() {
        this.SegmentService.createTrack(BLIP_STORE_INDICATED_VIEW_ALL_CLICKED_TRACKING);
        this.$state.go(blipStoreStateName);
        window.dispatchEvent(new CustomEvent('mfe-route-change', { detail: '/blip-store' }));
    }
    onOpenBlipStoreExtensionDetail(extensionId, extensionName) {
        this.SegmentService.createTrack(BLIP_STORE_INDICATED_EXTENSION_CLICKED_TRACKING, {
            extensionId: extensionId,
            extensionName: extensionName,
        });
        this.$state.go(blipStoreStateExtensionsDetail, { id: extensionId });
    }
}
IntegrationsController.$inject = ['application', '$translate', '$state', 'ConfigurationsService', 'IntegrationsSegmentService', 'ExternalBlipStoreService', 'SegmentService', '$location', 'TranslateService'];
